window.FA_QUIZ_FLOWS = window.FA_QUIZ_FLOWS || {};

window.FA_QUIZ_FLOWS['glp1'] = {
  id: 'glp1',
  klaviyoEvent: 'GLP-1 Quiz Completed',

  scoring: {
    map: {
      s1: [0, 1, 2, 3],
      s2: [1, 0],
      s3: [2, 3, 2, 2, 1],
      s4: [3, 0],
      s5: [3, 3, 2, 0],
      s6: [3, 2, 1, 0],
      s9: [0, 1, 2, 3],
      s10: [3, 2, 0, 0],
      s11: [3, 0, 1],
      s12: [0, 1, 2, 3]
    },
    tiers: [
      { id: 'high', min: 18 },
      { id: 'medium', min: 10 },
      { id: 'low', min: 0 }
    ],
    overrides: [
      { when: { s5: 3, s4: 1 }, force: 'low' },
      { when: { s6: 3 }, fromTier: 'high', toTier: 'medium' },
      { when: { s4: 0, s5: [0, 1] }, fromTier: 'low', toTier: 'medium' }
    ]
  },

  gauge: {
    title: 'Your GLP-1 Effectiveness',
    scoreLabel: 'Your score:',
    labels: ['STALLED', 'LOW', 'NORMAL', 'OPTIMAL']
  },

  chart: {
    yLabels: ['Optimal', 'Normal', 'Low', 'Stalled'],
    xLabels: ['Now', '30 days', '60 days', '90 days'],
    calloutLabel: 'Your level'
  },

  steps: [
    {
      id: 'question_1',
      type: 'hero',
      title: "Find out why your GLP-1 isn't <br>giving you the body you expected",
      sub: "This 2-minute assessment analyzes your GLP-1 progress, symptoms, and <br>muscle loss risk to find what's missing.",
      testimonial: { text: "I've started sending this to patients before their first visit. It asks the right questions for people on GLP-1", initial: 'P', name: 'DR. PAREKH', badge: 'LONGEVITY EXPERT' },
      qLabel: 'How old are you?',
      q: 's1',
      options: ['In my 20s', 'In my 30s', 'In my 40s', 'In my 50s or later']
    },
    {
      id: 'question_2',
      type: 'question',
      title: 'What best describes you?',
      q: 's2',
      options: ['Female', 'Male'],
      helper: 'GLP-1 muscle loss differs by biological sex. We tailor your results accordingly.'
    },
    {
      id: 'question_3',
      type: 'question',
      title: "What's been bothering you most <br>since starting GLP-1?",
      q: 's3',
      options: ['Looking "skinny fat" - smaller but soft', 'Losing muscle along with the fat', 'Constant fatigue and weakness', 'Loose, sagging skin', 'Weight loss is slowing down']
    },
    {
      id: 'question_4',
      type: 'question',
      title: "Do you feel weaker since starting GLP-1, like workouts feel harder or <br>your strength just isn't there?",
      titleWide: true,
      q: 's4',
      options: ['Yes', 'No']
    },
    {
      id: 'question_5',
      type: 'question',
      title: 'How does your body look now <br>compared to before GLP-1?',
      q: 's5',
      options: ['Skinny fat - smaller, but soft and undefined', 'Deflated - lost muscle along with the fat', 'Slimmer, but not as toned as I hoped', 'Leaner and toned - happy so far']
    },
    {
      id: 'question_6',
      type: 'question',
      title: 'When did you start your GLP-1 <br>medication?',
      q: 's6',
      options: ['Over a year ago', 'In the past year', 'In the past few months', "I haven't started yet"]
    },
    {
      id: 'question_7',
      type: 'question',
      title: "What's your number one goal with <br>GLP-1?",
      q: 's7',
      options: ['Lose fat without losing muscle', 'A toned, defined look - not skinny fat', 'Steady energy that lasts all day', 'Faster, longer-lasting results', 'All of the above']
    },
    {
      id: 'social_proof',
      type: 'interstitial',
      title: 'You are in the right place.',
      sub: 'Over 100,000+ GLP-1 users have kept their muscle, tone and energy while losing weight - with the right support.',
      cta: 'CONTINUE',
      testimonials: [
        { text: 'My weight kept dropping but I finally stopped looking flat and soft after the quiz', initial: 'J', name: 'JESSICA, 34', badge: 'Verified review' },
        { text: 'Still losing on my shot, but now my arms look toned instead of deflated. Thanks to the quiz', initial: 'A', name: 'AMANDA, 28', badge: 'Verified review' }
      ]
    },
    {
      id: 'question_8',
      type: 'question',
      title: 'How would you describe your <br>current body composition?',
      q: 's9',
      options: ['Lean and toned', 'Average build', 'Soft with some muscle', 'Out of shape / low muscle tone']
    },
    {
      id: 'question_9',
      type: 'question',
      title: 'How many hours of quality sleep <br>do you get per night?',
      q: 's10',
      options: ['Less than 5 hours', '5-6 hours', '7-8 hours', 'More than 8 hours']
    },
    {
      id: 'question_10',
      type: 'question',
      title: 'Do you struggle to eat enough <br>protein since starting GLP-1?',
      q: 's11',
      options: ['Yes', 'No', 'Not sure'],
      why: 'GLP-1s suppress appetite so much that most users under-eat protein and creatine - the two nutrients your muscles need to survive rapid weight loss. This is the #1 driver of "skinny fat" results.'
    },
    {
      id: 'analyzing',
      type: 'ring_loader',
      title: 'Analyzing your responses...',
      sub: 'Our algorithm is cross-referencing your answers with clinical GLP-1 data to find what your results are missing.',
      ringLabel: 'analyzes',
      duration: 4000
    },
    {
      id: 'question_11',
      type: 'question',
      title: 'How often do you eat red <br>meat or fish?',
      sub: '(These are the primary natural sources of creatine)',
      q: 's12',
      options: ['Daily - most meals include meat/fish', 'Several times a week', 'Occasionally - mostly plant-based', 'Rarely/never - vegetarian or vegan'],
      why: 'Red meat and fish are the primary dietary sources of creatine. GLP-1 appetite suppression drastically cuts both - draining the muscle fuel your body needs while losing weight.'
    },
    {
      id: 'building_profile',
      type: 'step_loader',
      variant: 'counter',
      title: 'Building your profile...',
      sub: 'Personalizing your GLP-1 assessment',
      onDone: 'score',
      steps: [
        { num: 1, title: 'Analyzing symptoms', text: 'Cross-checking your reported symptoms' },
        { num: 2, title: 'Cross-referencing lifestyle factors', text: 'Diet, sleep, and activity patterns' },
        { num: 3, title: 'Calibrating supplement protocol', text: 'Matching to clinical benchmarks' },
        { num: 4, title: 'Personalizing your result', text: 'Generating your assessment...' }
      ]
    },
    {
      id: 'results',
      type: 'result_gauge',
      eyebrow: 'YOUR GLP-1 ASSESSMENT',
      title: 'Your Results Are In',
      meansTitle: 'What This Means For You',
      cta: "SHOW ME WHAT'S POSSIBLE"
    },
    {
      id: 'projection',
      type: 'result_chart',
      eyebrow: 'YOUR PROJECTED IMPROVEMENT',
      title: 'GLP-1 Effectiveness Projection',
      sub: 'Based on your unique assessment profile',
      milestonesTitle: 'Expected Milestones',
      cta: 'SEE MY FULL PLAN'
    },
    {
      id: 'final_loader',
      type: 'step_loader',
      variant: 'ring',
      title: 'Finalizing your plan...',
      sub: 'Securing your personalized pricing',
      urgency: 'Your discount expires soon',
      onDone: 'redirect',
      steps: [
        { num: 1, title: 'Protocol calibrated', text: 'Your custom plan is ready' },
        { num: 2, title: 'Supply reserved', text: 'Stock allocated for your order' },
        { num: 3, title: 'Discount applied', text: '47% savings activated' },
        { num: 4, title: 'Generating your link', text: 'Creating secure checkout...' }
      ]
    }
  ],

  tiers: {
    high: {
      cls: 'fq-tier--high',
      levelLabel: 'CRITICALLY LOW',
      pct: '18%',
      activeSegment: 0,
      alertTitle: 'SEVERELY LIMITED',
      alertText: 'Your GLP-1 is burning muscle, not just fat. Immediate creatine support strongly recommended.',
      statusValue: 'CRITICAL',
      statusSub: 'STALLED',
      riskValue: 'HIGH',
      riskSub: 'IMPACT',
      potential: '+60%',
      meansIntro: 'Without support, your GLP-1 keeps burning muscle along with fat. This directly affects:',
      meansBullets: ['How toned you look as the weight drops', 'Muscle retention and strength', 'Daily energy and stamina', 'Your metabolism and long-term results'],
      meansClosing: '<strong>Good news, this is fixable, and creatine is one of the most effective solutions for your situation. Tap below to see which brand is right for you.</strong>',
      chartStartY: 3,
      lift: '+60%',
      levelColor: '#FF0000',
      calloutBg: '#FFE1E1',
      potentialColor: '#FF0000',
      milestones: [
        { label: 'WEEK 1-2', title: 'Loading Phase', text: 'Daily creatine support starts refueling your muscles - offsetting what GLP-1 appetite loss strips away.' },
        { label: 'WEEK 3-4', title: 'Activation Phase', text: 'Strength and energy climb. Your body starts burning fat while holding on to muscle.' },
        { label: 'MONTH 2-3', title: 'Optimization Phase', text: 'Full saturation reached. Your GLP-1 works at full speed - fat loss without the skinny-fat look.' }
      ]
    },
    medium: {
      cls: 'fq-tier--medium',
      levelLabel: 'PARTIALLY LIMITED',
      pct: '52%',
      activeSegment: 1,
      alertTitle: 'PARTIALLY LIMITED - DECLINING',
      alertText: 'Your GLP-1 is starting to burn muscle along with fat. Proactive creatine support recommended.',
      statusValue: 'MILD',
      statusSub: 'STALLED',
      riskValue: 'MODERATE',
      riskSub: 'IMPACT',
      potential: '+30%',
      meansIntro: 'Your GLP-1 results are starting to slip. You may be noticing:',
      meansBullets: ['Reduced energy throughout the day', 'Slower post-workout recovery', 'Softer, less defined look', 'Gradual loss of muscle tone'],
      meansClosing: '<strong>Good news, this is fixable, and creatine is one of the most effective solutions for your situation. Tap below to see which brand is right for you.</strong>',
      chartStartY: 2,
      lift: '+30%',
      levelColor: '#F19800',
      calloutBg: '#FFF3DF',
      potentialColor: '#3B7DDD',
      milestones: [
        { label: 'WEEK 1-2', title: 'Loading Phase', text: 'Daily creatine support begins restoring muscle fuel. Early strength and energy improvements.' },
        { label: 'WEEK 3-4', title: 'Stabilization', text: 'Steady improvement in tone, energy, and workout recovery.' },
        { label: 'MONTH 2-3', title: 'Optimization', text: 'Your GLP-1 now burns fat while you keep muscle. Full benefits realized.' }
      ]
    },
    low: {
      cls: 'fq-tier--low',
      levelLabel: 'NEARLY OPTIMAL',
      pct: '74%',
      activeSegment: 2,
      alertTitle: 'WORKING - ROOM TO OPTIMIZE',
      alertText: 'Your GLP-1 is working - but not at full speed.',
      statusValue: 'GOOD',
      statusSub: 'STALLED',
      riskValue: 'LOW',
      riskSub: 'IMPACT',
      potential: '+20%',
      meansIntro: "Your GLP-1 is performing well, but there's still untapped potential:",
      meansBullets: ['Enhanced energy and stamina throughout the day', 'Faster post-workout muscle recovery', 'A more toned, defined look as you lose', 'Better athletic performance and endurance'],
      meansClosing: '<strong>Many people at your level unlock noticeably faster results with creatine. Tap below to see which brand is right for you.</strong>',
      chartStartY: 1,
      lift: '+20%',
      levelColor: '#338411',
      calloutBg: '#E8F8E0',
      potentialColor: '#3B7DDD',
      milestones: [
        { label: 'WEEK 1-2', title: 'Top-Off Phase', text: 'Daily creatine support tops off your muscle fuel. Subtle strength and energy gains.' },
        { label: 'WEEK 3-4', title: 'Enhancement', text: 'Consistent boost in daily energy, focus, and workout performance.' },
        { label: 'MONTH 2-3', title: 'Peak Performance', text: 'Your GLP-1 at full speed - fat loss with zero muscle sacrificed.' }
      ]
    }
  }
};
